import {ModuleWithProviders, NgModule} from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {MsalGuard} from "./Middleware/msal-guard.service";
import {HubComponent} from "./hub/hub.component";
import { ExternoComponent } from './externo/externo.component';
import { TokenValidatorService } from './Middleware/token-validator.service';
import {Token} from "@angular/compiler";
import {HubExternoComponent} from "./hub-externo/hub-externo.component";
import {HibridValidatorService} from "./Middleware/hibrid-validator.service";


export const ROUTES: Routes = [
  {path: '', component: HubComponent, pathMatch: 'full'},
  {path: 'hub', component: HubComponent, pathMatch: 'full'},
  {path: 'hub-externo', component: HubExternoComponent, pathMatch: 'full'},
  {path: 'externo', component: ExternoComponent, pathMatch: 'full'},
  {path: 'externo/:user/:password', component: ExternoComponent, pathMatch: 'full'},
  { path: 'callcenter', loadChildren: () => import('./hojas-call-center/hojas-call-center.module').then(m => m.HojasCallCenterModule), canActivate: [HibridValidatorService]},
  { path: 'peticiones', loadChildren: () => import('./peticiones/peticiones.module').then(m => m.PeticionesModule), canActivate: [TokenValidatorService] },
];


@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(ROUTES, { enableTracing: false })
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
